import { render, staticRenderFns } from "./MaterialPreviewDialog.vue?vue&type=template&id=593168fe&scoped=true"
import script from "./MaterialPreviewDialog.vue?vue&type=script&lang=ts"
export * from "./MaterialPreviewDialog.vue?vue&type=script&lang=ts"
import style0 from "./MaterialPreviewDialog.vue?vue&type=style&index=0&id=593168fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593168fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('593168fe')) {
      api.createRecord('593168fe', component.options)
    } else {
      api.reload('593168fe', component.options)
    }
    module.hot.accept("./MaterialPreviewDialog.vue?vue&type=template&id=593168fe&scoped=true", function () {
      api.rerender('593168fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/MaterialPreviewDialog.vue"
export default component.exports